/**
 * ENG-5565: run-boundary marker injected into the agent's REPL alongside
 * manager-injected work, so per-injection token usage can later be attributed
 * to a run (and thence to a scheduled task / kanban card).
 *
 * The marker is delivered as a plain user turn (via tmux send-keys — see
 * `maybeInjectKanbanCheck` in apps/cli manager-worker) and is inert: an
 * HTML-style comment the agent ignores. The transcript per-turn parser
 * (ENG-5566) reads these markers to delimit which assistant turns belong to
 * which run.
 *
 * NOT for slash-command injects: a slash command sent via send-keys is parsed
 * by the REPL's keystroke-layer slash parser, so it carries NO marker (the
 * manager falls back to a time-bracket for those).
 */

/** Render the inert run-boundary marker line for `runId`. */
export function formatRunMarker(runId: string): string {
  return `<!-- agt-run:${runId} -->`;
}

/**
 * Matches a run-boundary marker and captures the run id (UUID v4 shape).
 * Used by the per-turn transcript parser to find injection boundaries inside
 * a shared persistent session's transcript.
 */
export const RUN_MARKER_RE =
  /<!--\s*agt-run:([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})\s*-->/;
